module.exports = __webpack_public_path__ + "img/shoyu_menu2.c2824a18.png";